const justunoPurchase = ({
    number,
    items: orderItems,
    total: {
        total_shipping,
        grand_total,
        total_tax,
        subtotal,
    }
}) => {
    window.juapp('order', number, {
        total: grand_total.value,
        subtotal: subtotal.value,
        tax: total_tax.value,
        shipping: total_shipping.value,
        currency: grand_total.currency
    });

    orderItems?.forEach(({
        product: { name, sku },
        quantity_ordered,
        product_sale_price: { value },
    }) => {
        juapp('orderItem', {
            productid: sku,
            sku: sku,
            name: name,
            quantity: quantity_ordered,
            price: value,
        });
    });
};

const justunoLoad = () => {
    window.juapp=window.juapp||function(){(window.juapp.q=window.juapp.q||[]).push(arguments)};
};

export {
    justunoLoad,
    justunoPurchase,
};
